import api from "./api";

export const registerVehicleForUser =
    async (
        userId,
        payload
    ) => {
        try {
            const formData =
                new FormData();

            formData.append(
                "user_id",
                userId
            );

            Object.entries(
                payload
            ).forEach(
                ([key, value]) => {
                    if (
                        ![
                            "blue_book",
                            "vehicle_image",
                        ].includes(
                            key
                        )
                    ) {
                        formData.append(
                            key,
                            value
                        );
                    }
                }
            );

            formData.append(
                "blue_book",
                payload.blue_book[0]
                    ?.file
            );

            formData.append(
                "vehicle_image",
                payload.vehicle_image[0]
                    ?.file
            );

            const response =
                await api.post(
                    "/vehicle-management/vehicles/register-for-user",
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };


export const updateVehicleForPartner =
    async (
        vehicleId,
        payload
    ) => {
        try {
            const formData =
                new FormData();

            if (
                payload.registration_number !==
                undefined
            ) {
                formData.append(
                    "registration_number",
                    payload.registration_number
                );
            }

            if (
                payload.vehicle_make !==
                undefined
            ) {
                formData.append(
                    "vehicle_make",
                    payload.vehicle_make
                );
            }

            if (
                payload.vehicle_model !==
                undefined
            ) {
                formData.append(
                    "vehicle_model",
                    payload.vehicle_model
                );
            }

            if (
                payload.vehicle_body_type !==
                undefined
            ) {
                formData.append(
                    "vehicle_body_type",
                    payload.vehicle_body_type
                );
            }

            if (
                payload.vehicle_color !==
                undefined
            ) {
                formData.append(
                    "vehicle_color",
                    payload.vehicle_color
                );
            }

            if (
                payload.chasis_number !==
                undefined
            ) {
                formData.append(
                    "chasis_number",
                    payload.chasis_number
                );
            }

            if (
                payload.engine_number !==
                undefined
            ) {
                formData.append(
                    "engine_number",
                    payload.engine_number
                );
            }

            if (
                payload.year_of_manufacturing !==
                undefined
            ) {
                formData.append(
                    "year_of_manufacturing",
                    payload.year_of_manufacturing
                );
            }

            if (
                payload.blue_book?.[0]
                    ?.file
            ) {
                formData.append(
                    "blue_book",
                    payload.blue_book[0].file
                );
            }

            if (
                payload.vehicle_image?.[0]
                    ?.file
            ) {
                formData.append(
                    "vehicle_image",
                    payload.vehicle_image[0].file
                );
            }

            const response =
                await api.put(
                    `/vehicle-management/vehicles/${vehicleId}/update-for-partner`,
                    formData,
                    {
                        headers: {
                            "Content-Type":
                                "multipart/form-data",
                        },
                    }
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message ||
                    "Failed to update vehicle information.",
            };
        }
    };


export const fetchRecruitedVehicles =
    async (
        page = 1,
        size = 10
    ) => {
        try {
            const response =
                await api.get(
                    `/vehicle-management/driver-partners/recruited-vehicles?page=${page}&size=${size}`
                );

            return {
                success: true,
                data:
                    response.data.data,
            };
        } catch (
            error
        ) {
            return {
                success: false,
                error:
                    error.response
                        ?.data
                        ?.detail ||
                    error.message,
            };
        }
    };